import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=6fa75d38&scoped=true&"
import script from "./GroupList.vue?vue&type=script&lang=js&"
export * from "./GroupList.vue?vue&type=script&lang=js&"
import style0 from "./GroupList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GroupList.vue?vue&type=style&index=1&id=6fa75d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa75d38",
  null
  
)

export default component.exports